import { useEffect, useState } from 'react';
import { useAuthenticatedFetch } from './useAuthenticatedFetch';

/** Variáveis do contato + campos personalizados + cupons da organização, para os botões "inserir variável" */
export function useMessageVariables(base: string[] = ['{{nome}}', '{{primeiro_nome}}', '{{telefone}}']): string[] {
  const fetchApi = useAuthenticatedFetch();
  const [fields, setFields] = useState<string[]>([]);
  useEffect(() => {
    let alive = true;
    Promise.all([
      fetchApi('/api/custom-fields').then((r) => (r.ok ? r.json() : null)).catch(() => null),
      fetchApi('/api/coupons').then((r) => (r.ok ? r.json() : null)).catch(() => null),
    ]).then(([f, c]) => {
      if (!alive) return;
      setFields([
        ...((f?.fields ?? []) as Array<{ key: string }>).map((x) => `{{${x.key}}}`),
        ...((c?.campaigns ?? []) as Array<{ key: string; active: boolean }>).filter((x) => x.active).map((x) => `{{cupom:${x.key}}}`),
      ]);
    });
    return () => { alive = false; };
  }, [fetchApi]);
  return [...base, ...fields.filter((f) => !base.includes(f))];
}
